import { RevisionAnnotation } from "types/RevisionAnnotation";

export const useDraggingAnnotation = defineStore(
  "/draggingAnnotation",
  () => {
    const annotationBeingDragged = ref<RevisionAnnotation | undefined>(
      undefined
    );

    const setAnnotationBeingDragged = (
      annotation: RevisionAnnotation | undefined
    ) => {
      annotationBeingDragged.value = annotation;
    };

    const isAnnotationBeingDragged = computed(() => {
      return (annotation: RevisionAnnotation) => {
        return annotationBeingDragged.value?.id === annotation.id;
      };
    });

    const isAnAnnotationBeingDragged = computed(() => {
      return annotationBeingDragged.value !== undefined;
    });

    const selectedTokenGlobalPosition = ref<number | undefined>(undefined);

    const setSelectedTokenGlobalPosition = (position: number | undefined) => {
      selectedTokenGlobalPosition.value = position;
    };

    const removeSelectedTokenGlobalPosition = (position: number) => {
      if (selectedTokenGlobalPosition.value === position) {
        selectedTokenGlobalPosition.value = undefined;
      }
    };

    const isTokenDraggingSelected = computed(() => {
      return (position: number) => {
        return selectedTokenGlobalPosition.value === position;
      };
    });

    watch(selectedTokenGlobalPosition, (position) => {
      const tokenPositions = [];

      if (position) {
        tokenPositions.push(position);
      }

      useApplyClassToTokens(tokenPositions, "token-is-dragging-selected");
    });

    return {
      annotationBeingDragged,
      setAnnotationBeingDragged,
      isAnAnnotationBeingDragged,
      isAnnotationBeingDragged,
      setSelectedTokenGlobalPosition,
      removeSelectedTokenGlobalPosition,
      isTokenDraggingSelected,
      selectedTokenGlobalPosition,
    };
  }
);
